<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$store.commit('setModalAddMultipleUserStatus', false)">
            Użytkownicy
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <p class="text-center">Prawidłowy format danych jest oddzielony przecinkiem tj.:</p>
            <p class="text-center">imię,nazwisko,Radni,adres e-mail, telefon np:</p>
            <p class="text-center" style="font-weight: bold">Jan,Kowalski,Radni,jan@kowalski,123456789</p>
            <p class="text-center" style="font-weight: bold; color: red">Dane każdego użytkownika należy rozpoczynać od nowej linii</p>
            <p class="text-center" style="font-weight: bold; color: red">(po enterze) i nie należy pozostawiać pustych linii.</p>
            <eSesjaTab>
                <eSesjaTabNav id="tabMultileUser">
                    <eSesjaTabNavItem id="from-text-tab"
                                      href="from-text-content"
                                      :isActive="true"
                                      @click="setMode('from-text')">
                        Z tekstu
                    </eSesjaTabNavItem>
                    <!--<eSesjaTabNavItem id="from-file-tab"
                                      href="from-file-content"
                                      @click="setMode('from-file')">
                        Z Pliku
                    </eSesjaTabNavItem>-->
                </eSesjaTabNav>
                <eSesjaTabContent>
                    <eSesjaTabPane tabId="from-text-content" :isActive="true">
                        <p>Wprowadź dane użytkowników którzy mają zostać zaimportowani</p>
                        <textarea v-model="inlineData" class="inline-data" cols="5" rows="10"></textarea>
                    </eSesjaTabPane>
                    <eSesjaTabPane tabId="from-file-content">
                        <p>Wybierz plik, z którego ma zostać dokonany import użytkowników</p>
                        <InputFileComponent @change="fileChanged" />
                    </eSesjaTabPane>
                </eSesjaTabContent>
            </eSesjaTab>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$store.commit('setModalAddMultipleUserStatus', false)">
                Anuluj
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @click="parseData">
                Zapisz
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">

    import InputFileComponent from "../../../BasicControls/InputFileComponent.vue";

    import userCsvParserService from "../../../../services/user.csv.parser.service";

    export default {
        name: "AddMultipleUsersModal",
        emits: ["parsedGroups"],
        components: {
            InputFileComponent,
        },
        props: {
            availableGroups: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                mode: "from-text",
                inlineData: "",
            }
        },
        methods: {
            setMode(newMode) {
                this.mode = newMode;
            },

            parseData() {
                if (this.mode === "from-file") {
                    // potrzeba wpisać inlinową data
                }

                let result = userCsvParserService.Parse(this.inlineData, this.availableGroups);
                this.$store.commit('setModalAddMultipleUserStatus', false)
                this.$emit('parsedGroups', result);
            },

            fileChanged(data) {
                let files = data?.target?.files ?? [];

                if (files?.length !== 1) {
                    // bład
                    return;
                }

                let file = files[0];

                let reader = new FileReader();
                reader.onloadend = (event) => {
                    this.inlineData = event.target.result;
                };
                reader.readAsText(file, "UTF-8");
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '@/assets/scss/esesja-modal.scss';

    .inline-data {
        padding: 12.5px 16px;
        background: #ffffff;
        border: 1px solid #d1d6df;
        box-sizing: border-box;
        box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
        border-radius: 4px;
        width: 600px;
        height: 150px;
        font-size: 16px;
        color: #00082c;

        &:focus {
            border: 1px solid #00082c;
        }

        &::placeholder {
            font-size: 16px;
            line-height: 144%;
            color: #808396;
        }

        &--adjust-width {
            width: 100%;
            min-width: 238px;
        }
    }
</style>